import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=336a59ac&scoped=true&"
import script from "./OurTeam.vue?vue&type=script&lang=js&"
export * from "./OurTeam.vue?vue&type=script&lang=js&"
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=336a59ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336a59ac",
  null
  
)

export default component.exports